import React from 'react';
import styles from './mailConfirmationForm.module.css';

import { Title } from '../Title';
import { Description } from '../Description';
import { Content } from '../Content';
import { EmailButton } from '../EmailButton';
import { ActionItem } from '../ActionItem';

interface Props {
  email: string;
  onClose: () => void;
  emailIsConfirmed: boolean;
}

export const MailConfirmationForm: React.FC<Props> = ({
  email,
  onClose,
  emailIsConfirmed,
}) => (
  <>
    <Title>Установите пароль</Title>
    {!emailIsConfirmed && (
      <Description>
        Вам на почту отправлено письмо. Перейдите по ссылке в этом письме и
        установите пароль, по которому в дальнейшем сможете входить в аккаунт.
        Это удобно в поездке, когда не всегда есть возможность получить смс и
        войти по номеру телефона.
      </Description>
    )}
    <Content>
      {!emailIsConfirmed && <EmailButton email={email} />}
      <ActionItem className={styles.actionItem} onClick={onClose}>
        Перейти к турам
      </ActionItem>
    </Content>
  </>
);
